const { ucFirst } = require('./ucFirst')

/**
 * Egy szöveg camelCase-esítése.
 * @param {string} str - A szöveg.
 * @returns {string} A camelCase szöveg.
 */
module.exports.camelize = function camelize (str) {
  return str
    // Speckó karaktereket kiszedjük és space-re cseréljük.
    .replace(/[!\-<>_|]/g, ' ')
    // Multi space → Single space.
    .replace(/\s{2,}/g, ' ')
    // Trimmeljük is a biztonság kedvéért.
    .trim()
    // Darabokra szedjük.
    .split(/\s+/)
    // Az elsőt lower, a többi upper.
    .map((part, index) => {
      return index === 0 ? part.toLowerCase() : ucFirst(part)
    })
    // Végül összerakjuk.
    .join('')
}
